import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DownloadIcon, KeyIcon, LogInIcon, HomeIcon, CalendarIcon, CheckCircleIcon, LineChartIcon, BellIcon, CreditCardIcon, BookOpenIcon, PencilIcon, VideoIcon, AppleIcon, SmartphoneIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const TotalDrivePage = () => {
  return <div className="bg-white" data-id="element-2072" data-mp="2jy92ztya0hva">
      <Helmet data-id="element-2073" data-mp="2jz10597iunno">
        <title data-id="element-2074" data-mp="2jyhhfqa1rv8l">Total Drive App Guide | Northampton Driving School</title>
        <meta name="description" content="Learn how to use the Total Drive app for booking driving lessons in Northampton, tracking progress, making payments, and more with our step-by-step guide." data-id="element-2075" data-mp="2nzuog3ovm4h3" />
        <meta name="keywords" content="Total Drive app, driving lesson app, Northampton driving lessons, book driving lessons online, driving lesson progress tracker, driving lesson payment app" data-id="element-2076" data-mp="2exbmrmwttxwf" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-2077" data-mp="1s6c5v35tz2zh">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-2078" data-mp="1s6u8chj36dfu">
          Total Drive App Guide
        </h1>
        {/* Intro Section */}
        <section className="mb-12 bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-2079" data-mp="1o737fkzuigxl">
          <h2 className="text-2xl font-bold mb-4" data-id="element-2080" data-mp="222f5a19asniq">
            Simplify Your Learning Journey
          </h2>
          <p className="text-gray-700 mb-4" data-id="element-2081" data-mp="1x7rnel8surd4">
            At Northampton Driving School, we use the Total Drive app to make
            learning simple and stress-free. With the app, you can:
          </p>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6" data-id="element-2082" data-mp="2kuztv6hys6gq">
            <li className="flex items-start" data-id="element-2083" data-mp="2ku7x3scms2ov">
              <CalendarIcon className="text-burgundy-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-2084" data-mp="2fveitxpis7nn" />
              <span data-id="element-2085" data-mp="2utp0u48bo6i7">Book your driving lessons in Northampton</span>
            </li>
            <li className="flex items-start" data-id="element-2086" data-mp="2pv5dbze2ymnq">
              <LineChartIcon className="text-burgundy-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-2087" data-mp="2ps9hcglsm81x" />
              <span data-id="element-2088" data-mp="31vlx925wl50a">Track your progress with your instructor</span>
            </li>
            <li className="flex items-start" data-id="element-2089" data-mp="36uyglcxkfty4">
              <CreditCardIcon className="text-burgundy-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-2090" data-mp="36tvnqzgonhfk" />
              <span data-id="element-2091" data-mp="3gljo5pv7w8t6">Pay for lessons securely</span>
            </li>
            <li className="flex items-start" data-id="element-2092" data-mp="3gl01xwyjay9c">
              <BellIcon className="text-burgundy-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-2093" data-mp="3kmbvueofy5nc" />
              <span data-id="element-2094" data-mp="3pmhgvc07gtwg">Receive notifications and reminders</span>
            </li>
          </ul>
          <p className="text-gray-700" data-id="element-2095" data-mp="3ujq59uby5u65">
            Follow this step-by-step guide with screenshots to get started.
          </p>
        </section>
        {/* Step-by-Step Guide */}
        <div className="space-y-12" data-id="element-2096" data-mp="2082xz8bvc18v">
          {/* Step 1 */}
          <section id="step1" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2097" data-mp="1snimdjpkf2ut">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2098" data-mp="1nwin47sz48p5">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2099" data-mp="1ixpa0ghlmjpi">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2100" data-mp="1ixz1y9m7f0xu">
                  1
                </span>
                Download the Total Drive App
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2101" data-mp="26n0fucdt34ai">
              <div data-id="element-2102" data-mp="21o72cjyirdac">
                <p className="mb-4" data-id="element-2103" data-mp="21ne1u0q5lk0n">Download from:</p>
                <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-2104" data-mp="21q9yzmu6g4o1">
                  <a href="https://apps.apple.com/gb/app/total-drive/id1446269375" target="_blank" rel="noopener noreferrer" className="flex items-center" data-id="element-2105" data-mp="1woaxkihzzhtq">
                    <img src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg" alt="Download on the App Store" className="h-12" data-id="element-2106" data-mp="2a4ee91hv7v29" />
                  </a>
                  <a href="https://play.google.com/store/apps/details?id=com.totaldrive.com.totaldrive&hl=en_GB" target="_blank" rel="noopener noreferrer" className="flex items-center" data-id="element-2107" data-mp="2551jzvonzlpn">
                    <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Get it on Google Play" className="h-14" data-id="element-2108" data-mp="2xrcr7p6s0kvf" />
                  </a>
                </div>
                <p className="mb-4" data-id="element-2109" data-mp="17jm9tta81l1z">
                  <span className="font-medium" data-id="element-2110" data-mp="1cgvy35lvjqo8">1.</span> Open the app and
                  select <strong data-id="element-2111" data-mp="3qnvfx7qnodyx">Pupil / Parent</strong>.
                </p>
              </div>
              <div className="flex justify-center" data-id="element-2112" data-mp="3lp0z2bc90zhg">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fchFF5RWyasy6zz1WoRWeZ/01._Step_1.jpg" alt="Total Drive App Welcome Screen" className="max-w-[250px] border border-gray-300 rounded-md shadow-md" data-id="element-2113" data-mp="3lo93v1mkd3rp" />
              </div>
            </div>
          </section>
          {/* Step 2 */}
          <section id="step2" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2114" data-mp="32z2q7t0mn2cr">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2115" data-mp="3gqr2pxesfsu9">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2116" data-mp="3byphvn3k0tsm">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2117" data-mp="3bxedbl2abi0g">
                  2
                </span>
                Enter Your Driving School PIN
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2118" data-mp="n6nj2zdru14m">
              <div data-id="element-2119" data-mp="s5qhw235rb45">
                <p className="mb-4" data-id="element-2120" data-mp="s578xavhjx29">
                  <span className="font-medium" data-id="element-2121" data-mp="s45nccgufs6a">1.</span> Enter the 4-digit PIN
                  sent by your instructor.
                </p>
                <p className="mb-4" data-id="element-2122" data-mp="11wl4j7kbgcq4">
                  <span className="font-medium" data-id="element-2123" data-mp="11vjqqvbx1c4p">2.</span> Tap{' '}
                  <strong data-id="element-2124" data-mp="49mgfl7owd3u">Continue</strong>.
                </p>
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-6" data-id="element-2125" data-mp="97o0a8cxwggd">
                  <p className="text-sm text-yellow-800" data-id="element-2126" data-mp="99h65lfqawnb">
                    <strong data-id="element-2127" data-mp="e5xuafmxhb0e">Tip:</strong> Don't have a PIN? Contact your
                    Northampton Driving School instructor to get your unique
                    code.
                  </p>
                </div>
              </div>
              <div className="flex justify-center" data-id="element-2128" data-mp="1po8o14f90lid">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8kd2oG1RPMEfFy7oPFtUzC/01._Step_2.jpg" alt="Total Drive App PIN Entry Screen" className="max-w-[250px] border border-gray-300 rounded-md shadow-md" data-id="element-2129" data-mp="1ujxsnm64kslj" />
              </div>
            </div>
          </section>
          {/* Step 3 */}
          <section id="step3" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2130" data-mp="30eewlv6g5i56">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2131" data-mp="2vg3mrkg5j7my">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2132" data-mp="2rdp4b1gea9w7">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2133" data-mp="2rfjouenr7zzr">
                  3
                </span>
                Log In to Your Account
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2134" data-mp="kly1voagcagd">
              <div data-id="element-2135" data-mp="fo6082k099yz">
                <p className="mb-4" data-id="element-2136" data-mp="foxtv7u1kxmm">
                  <span className="font-medium" data-id="element-2137" data-mp="fopixlhhc2e2">1.</span> Enter your mobile
                  number and password (provided via text).
                </p>
                <p className="mb-4" data-id="element-2138" data-mp="3pnapvrjcpbo3">
                  <span className="font-medium" data-id="element-2139" data-mp="3pm9dnjqlmj4s">2.</span> Tap{' '}
                  <strong data-id="element-2140" data-mp="3aywmnfi0vl70">Login</strong> and accept the terms and conditions.
                </p>
                <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mt-6" data-id="element-2141" data-mp="3fwg2gjudc612">
                  <p className="text-sm text-blue-800" data-id="element-2142" data-mp="31xq8ve6rcohg">
                    <strong data-id="element-2143" data-mp="31w5blgt26rfw">Note:</strong> If you haven't received your login
                    details, please contact your instructor.
                  </p>
                </div>
              </div>
              <div className="flex justify-center gap-4" data-id="element-2144" data-mp="2s13lahn1rjbq">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/87gBv1txfEfPqrMaoh2FjX/03._Step_3.jpg" alt="Total Drive App Login Screen" className="max-w-[250px] border border-gray-300 rounded-md shadow-md" data-id="element-2145" data-mp="2wxkcjkpjmdt1" />
              </div>
            </div>
          </section>
          {/* Step 4 */}
          <section id="step4" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2146" data-mp="2apyap4h5ree8">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2147" data-mp="2pf4dt3j49ore">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2148" data-mp="2ko4fpuy9h0nb">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2149" data-mp="2kmtbxv4tfsw7">
                  4
                </span>
                Explore the Home Screen
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2150" data-mp="38dyrsaaral6i">
              <div data-id="element-2151" data-mp="33em1ffkoevz6">
                <p className="mb-4" data-id="element-2152" data-mp="33ecczwfa4wvl">On the home screen, you can:</p>
                <ul className="space-y-3 mb-6" data-id="element-2153" data-mp="33cssftmlbzo0">
                  <li className="flex items-start" data-id="element-2154" data-mp="1e0qtg8nknrg4">
                    <CalendarIcon className="text-burgundy-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-2155" data-mp="190kvkaqpl8pl" />
                    <span data-id="element-2156" data-mp="2pltljlzf6d5r">View your next driving lesson at a glance</span>
                  </li>
                  <li className="flex items-start" data-id="element-2157" data-mp="2kjku4u273j5r">
                    <CreditCardIcon className="text-burgundy-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-2158" data-mp="2flt4y7sxqb59" />
                    <span data-id="element-2159" data-mp="2bmkat1tzgb96">Pay for lessons</span>
                  </li>
                  <li className="flex items-start" data-id="element-2160" data-mp="389f6lailr5ph">
                    <BookOpenIcon className="text-burgundy-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-2161" data-mp="33bx4a2z3boqg" />
                    <span data-id="element-2162" data-mp="2yj429mv0aui2">Access learning resources</span>
                  </li>
                  <li className="flex items-start" data-id="element-2163" data-mp="2uik3yfyp5kuc">
                    <CalendarIcon className="text-burgundy-600 mr-2 mt-1 flex-shrink-0" size={18} data-id="element-2164" data-mp="3r0zjz5a5z7ib" />
                    <span data-id="element-2165" data-mp="3m983xoomwk6f">Check available lesson gaps</span>
                  </li>
                </ul>
              </div>
              <div className="flex justify-center" data-id="element-2166" data-mp="18u7wozbacu6h">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sZg5qHV1hWY2oqPQG9pxnu/04._Student_Home_Screen.jpg" alt="Total Drive App Home Screen" className="max-w-[250px] border border-gray-300 rounded-md shadow-md" data-id="element-2167" data-mp="1drrc42jpzd00" />
              </div>
            </div>
          </section>
          {/* Step 5 */}
          <section id="step5" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2168" data-mp="1wp0wblwvcuib">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2169" data-mp="21h2grv46xrjf">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2170" data-mp="25ie05iwh1gj6">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2171" data-mp="2ah8spck8qjgh">
                  5
                </span>
                Manage Your Driving Lessons
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2172" data-mp="fels1na0jd12">
              <div data-id="element-2173" data-mp="afr3s5ta0w9k">
                <p className="mb-4" data-id="element-2174" data-mp="agkc3b7vvttt">
                  <span className="font-medium" data-id="element-2175" data-mp="p3vm38of35rt">1.</span> Tap the{' '}
                  <strong data-id="element-2176" data-mp="p56pv8hv4dix">Lessons</strong> icon.
                </p>
                <p className="mb-4" data-id="element-2177" data-mp="kcvsodeib5u2">
                  <span className="font-medium" data-id="element-2178" data-mp="kbuazq2zjl3d">2.</span> Switch between Future
                  Lessons and Past Lessons.
                </p>
                <p className="mb-4" data-id="element-2179" data-mp="u3hzpj85qo15">
                  <span className="font-medium" data-id="element-2180" data-mp="u2f9ldinspma">3.</span> Tap the arrow to view
                  lesson details (pick-up/drop-off).
                </p>
                <div className="bg-green-50 border-l-4 border-green-400 p-4 mt-6" data-id="element-2181" data-mp="133wncp8lgf7t">
                  <p className="text-sm text-green-800" data-id="element-2182" data-mp="131u0uf6nh47u">
                    <strong data-id="element-2183" data-mp="39uw3xjaqrvak">Tip:</strong> You can see your total delivered,
                    cancelled, and booked hours at the top of the screen.
                  </p>
                </div>
              </div>
              <div className="flex justify-center" data-id="element-2184" data-mp="1kdhcd2a5cbjl">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sEaLNL3tXsQjznQWP5tTN1/05._Lessons_2.jpg" alt="Total Drive App Lessons Screen" className="max-w-[250px] border border-gray-300 rounded-md shadow-md" data-id="element-2185" data-mp="1pclkdplc438c" />
              </div>
            </div>
          </section>
          {/* Step 6 */}
          <section id="step6" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2186" data-mp="11ou82lzsnq72">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2187" data-mp="rotk2mqzclwj">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2188" data-mp="rqo9ad9ab06f">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2189" data-mp="wnwqobmlz06m">
                  6
                </span>
                Check In for Your Lessons
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2190" data-mp="qzodl3bnxal4">
              <div data-id="element-2191" data-mp="qwtsd9ktrlqn">
                <p className="mb-4" data-id="element-2192" data-mp="mx1jevrirdkr">
                  <span className="font-medium" data-id="element-2193" data-mp="my2uv1cg6230">1.</span> On your home screen,
                  you'll see your upcoming lessons.
                </p>
                <p className="mb-4" data-id="element-2194" data-mp="cznf1uivef8t">
                  <span className="font-medium" data-id="element-2195" data-mp="cyc2p6bczz63">2.</span> Tap the{' '}
                  <strong data-id="element-2196" data-mp="80tzzxnxqg6j">Check In</strong> button when you're ready for your
                  lesson.
                </p>
                <p className="mb-4" data-id="element-2197" data-mp="38j02ut72udz">
                  <span className="font-medium" data-id="element-2198" data-mp="37hbdnj9a9ds">3.</span> You'll receive a
                  confirmation message when you've successfully checked in.
                </p>
                <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mt-6" data-id="element-2199" data-mp="3qfl154ckn11b">
                  <p className="text-sm text-blue-800" data-id="element-2200" data-mp="3lfglfgjhmac5">
                    <strong data-id="element-2201" data-mp="3lh1fl51w3r9h">Note:</strong> Checking in lets your instructor know
                    you're ready for your lesson, helping them stay on schedule.
                  </p>
                </div>
              </div>
              <div className="flex flex-col justify-center gap-4" data-id="element-2202" data-mp="3bb05kn60ct8c">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2ghQFvuhW9ss5gBLwk5yKY/06._Check_In.jpg" alt="Total Drive App Check In Button" className="max-w-[250px] border border-gray-300 rounded-md shadow-md mx-auto" data-id="element-2203" data-mp="3bdcujka6o3uw" />
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fnUA3X8DKd2JrLjQz8yd9c/06._Check_In_2.jpg" alt="Total Drive App Check In Confirmation" className="max-w-[250px] border border-gray-300 rounded-md shadow-md mx-auto" data-id="element-2204" data-mp="2njl1opyl23uz" />
              </div>
            </div>
          </section>
          {/* Step 7 */}
          <section id="step7" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2205" data-mp="24t3l1jr0yypz">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2206" data-mp="21tbj1mrpv0vl">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2207" data-mp="21ria20tms4kf">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2208" data-mp="1wtgp1acn9v6b">
                  7
                </span>
                Track Your Driving Progress
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2209" data-mp="1iuh3ibkfhwed">
              <div data-id="element-2210" data-mp="1iwtjij6mlwos">
                <p className="mb-4" data-id="element-2211" data-mp="1dvnqslcyu9f9">
                  <span className="font-medium" data-id="element-2212" data-mp="1dwpblhjsaaa6">1.</span> Tap the{' '}
                  <strong data-id="element-2213" data-mp="1ssn6kwhz18kt">Favorites</strong> icon (star) in the bottom
                  navigation.
                </p>
                <p className="mb-4" data-id="element-2214" data-mp="1ntk6zrkrfuk8">
                  <span className="font-medium" data-id="element-2215" data-mp="1nsim6vdxztpb">2.</span> View your syllabus
                  completion percentage and skill levels.
                </p>
                <p className="mb-4" data-id="element-2216" data-mp="2z9s3pcdigbnz">
                  <span className="font-medium" data-id="element-2217" data-mp="2z8h3tnn6ro25">3.</span> Track your progress on
                  specific skills like cockpit checks, moving off, and more.
                </p>
                <div className="bg-green-50 border-l-4 border-green-400 p-4 mt-6" data-id="element-2218" data-mp="3bsmahbljgann">
                  <p className="text-sm text-green-800" data-id="element-2219" data-mp="2xslby2sqxfbc">
                    <strong data-id="element-2220" data-mp="2xu679umvx2a9">Tip:</strong> Your instructor updates these ratings
                    after each lesson, so you can see how you're improving over
                    time.
                  </p>
                </div>
              </div>
              <div className="flex justify-center" data-id="element-2221" data-mp="3uic7848v36i7">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i7D9GtBUrRTZPqYHsd9gmg/07._Progress_Performance.jpg" alt="Total Drive App Progress Tracking" className="max-w-[250px] border border-gray-300 rounded-md shadow-md" data-id="element-2222" data-mp="3ujx1dsr9knfj" />
              </div>
            </div>
          </section>
          {/* Step 8 */}
          <section id="step8" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2223" data-mp="h5ah4d7g6zbi">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2224" data-mp="3jrhbd3dis2b8">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2225" data-mp="3jp4k1zlvgfli">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2226" data-mp="3et5yejrxhbos">
                  8
                </span>
                Check Notifications & Messages
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2227" data-mp="6ckpt437kkm7">
              <div data-id="element-2228" data-mp="6a8c534hgwey">
                <p className="mb-4" data-id="element-2229" data-mp="1cyb0q7qewba">
                  <span className="font-medium" data-id="element-2230" data-mp="1c6n81kdm2vk">1.</span> Tap the{' '}
                  <strong data-id="element-2231" data-mp="3sk127hnkl2li">Bell</strong> icon in the bottom navigation to access
                  your inbox.
                </p>
                <p className="mb-4" data-id="element-2232" data-mp="2m4idwqf06qca">
                  <span className="font-medium" data-id="element-2233" data-mp="2m1cofa2gpmg1">2.</span> Here you'll find
                  important notifications about:
                </p>
                <ul className="space-y-2 mb-6 pl-6" data-id="element-2234" data-mp="wn37x4dnv41s">
                  <li className="list-disc" data-id="element-2235" data-mp="wk8q7km17xc2">
                    Available lesson gaps you can book
                  </li>
                  <li className="list-disc" data-id="element-2236" data-mp="16krgax46wa2f">
                    New lessons that have been added
                  </li>
                  <li className="list-disc" data-id="element-2237" data-mp="1bbhk45wyw4v0">
                    Updates to your progress syllabus
                  </li>
                  <li className="list-disc" data-id="element-2238" data-mp="1g9j4cu64qa82">Messages from your instructor</li>
                </ul>
                <p className="mb-4" data-id="element-2239" data-mp="1kal379w4wk9i">
                  <span className="font-medium" data-id="element-2240" data-mp="1kdqu8uobpw7v">3.</span> You can also send
                  messages to your instructor using the text box at the bottom.
                </p>
              </div>
              <div className="flex justify-center" data-id="element-2241" data-mp="1u7zih66bn308">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rnZfQJfhv81y4fgQwsmTD8/08._Notifications.jpg" alt="Total Drive App Notifications" className="max-w-[250px] border border-gray-300 rounded-md shadow-md" data-id="element-2242" data-mp="3r3dubuc0n4pj" />
              </div>
            </div>
          </section>
          {/* Step 9 */}
          <section id="step9" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2243" data-mp="2d09ac83kh9a4">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2244" data-mp="2hsaushaw26b8">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2245" data-mp="2mquesc5x980y">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2246" data-mp="2msovfea5udz8">
                  9
                </span>
                Make Payments for Lessons
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2247" data-mp="30pbylyspi0dl">
              <div data-id="element-2248" data-mp="12b8zn972ks0c">
                <p className="mb-4" data-id="element-2249" data-mp="12bshyr0mtiew">
                  <span className="font-medium" data-id="element-2250" data-mp="12ctwj5guwn1d">1.</span> Tap the{' '}
                  <strong data-id="element-2251" data-mp="16d41qfwtr9f6">Card</strong> icon in the bottom navigation.
                </p>
                <p className="mb-4" data-id="element-2252" data-mp="ytv1bc6aql29">
                  <span className="font-medium" data-id="element-2253" data-mp="yuwdjjz1tdlk">2.</span> View your payment
                  history, including:
                </p>
                <ul className="space-y-2 mb-6 pl-6" data-id="element-2254" data-mp="p2qlybcpky6w">
                  <li className="list-disc" data-id="element-2255" data-mp="p39vb3oame9b">Hours purchased</li>
                  <li className="list-disc" data-id="element-2256" data-mp="l27volqgs06t">Hours delivered</li>
                  <li className="list-disc" data-id="element-2257" data-mp="1hrp7lig1iigy">Credit remaining</li>
                </ul>
                <p className="mb-4" data-id="element-2258" data-mp="1hpl3p0i55jgo">
                  <span className="font-medium" data-id="element-2259" data-mp="1cs2x3grljgbu">3.</span> To make a payment, tap
                  the <strong data-id="element-2260" data-mp="18qr20vpye2w9">Pay</strong> button.
                </p>
                <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mt-6" data-id="element-2261" data-mp="18p69fbn78u11">
                  <p className="text-sm text-blue-800" data-id="element-2262" data-mp="13refyd6wozuq">
                    <strong data-id="element-2263" data-mp="3tgyhehkcqp2o">Note:</strong> All payments are secure and you'll
                    receive a confirmation email after each transaction.
                  </p>
                </div>
              </div>
              <div className="flex justify-center" data-id="element-2264" data-mp="3pz13vblbc7u9">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wiLiGzKARsbXPcg4NCrhoz/8._Payments.jpg" alt="Total Drive App Payments Screen" className="max-w-[250px] border border-gray-300 rounded-md shadow-md" data-id="element-2265" data-mp="3px7tpmbhr5hi" />
              </div>
            </div>
          </section>
          {/* Step 10 */}
          <section id="step10" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2266" data-mp="3778ahg2c0km0">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2267" data-mp="3c1cj03r8x0p7">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2268" data-mp="2xc7zmj8psqfi">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2269" data-mp="3296oondiu76u">
                  10
                </span>
                Access Learning Resources
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2270" data-mp="2tausm5tvyh70">
              <div data-id="element-2271" data-mp="29nrvzgzkmehd">
                <p className="mb-4" data-id="element-2272" data-mp="29pcicjbqer45">
                  <span className="font-medium" data-id="element-2273" data-mp="24ooprt7uu27t">1.</span> From the home screen,
                  tap the <strong data-id="element-2274" data-mp="2inogr7iuat75">Resources</strong> button.
                </p>
                <p className="mb-4" data-id="element-2275" data-mp="2iltu9orx6t0y">
                  <span className="font-medium" data-id="element-2276" data-mp="2elte9zp6a9rs">2.</span> Access helpful tools
                  such as:
                </p>
                <ul className="space-y-2 mb-6 pl-6" data-id="element-2277" data-mp="2sl2mac385xko">
                  <li className="list-disc" data-id="element-2278" data-mp="2nn0zph6lbg4g">Book Theory Test</li>
                  <li className="list-disc" data-id="element-2279" data-mp="2nmr9ptljp8yr">Book Driving Test</li>
                  <li className="list-disc" data-id="element-2280" data-mp="32c6zb69cb8cv">MOT Check for vehicles</li>
                </ul>
                <p className="mb-4" data-id="element-2281" data-mp="2xcawvbgajozf">
                  <span className="font-medium" data-id="element-2282" data-mp="2xdcejyrtb9q4">3.</span> These resources link
                  directly to official DVSA services to make booking easy.
                </p>
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mt-6" data-id="element-2283" data-mp="36ek3hq8fuy7j">
                  <p className="text-sm text-yellow-800" data-id="element-2284" data-mp="14ouxs42oya3a">
                    <strong data-id="element-2285" data-mp="14m8r06nmjym4">Tip:</strong> Your instructor can advise when you're
                    ready to book your theory or practical test.
                  </p>
                </div>
              </div>
              <div className="flex flex-col justify-center gap-4" data-id="element-2286" data-mp="1egin9zfoth24">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/w62cYShYUxT7SixVzRXVz9/9._Resources.jpg" alt="Total Drive App Resources Button" className="max-w-[250px] border border-gray-300 rounded-md shadow-md mx-auto" data-id="element-2287" data-mp="1if8a0imm8ayf" />
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tPSzB8qgWvdzoFXtkjkTHf/9._Resources_2.jpg" alt="Total Drive App Resources Screen" className="max-w-[250px] border border-gray-300 rounded-md shadow-md mx-auto" data-id="element-2288" data-mp="uom3ivs9eyqj" />
              </div>
            </div>
          </section>
          {/* Step 11 */}
          <section id="step11" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2289" data-mp="2l710qoww8bfp">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2290" data-mp="2gbc4aug67anm">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2291" data-mp="2bh7xcb6wn2mj">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2292" data-mp="27hh1vu6fnybo">
                  11
                </span>
                Practice for Your Theory Test
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2293" data-mp="1xl48kxesvmhg">
              <div data-id="element-2294" data-mp="1sk6qektsisfy">
                <p className="mb-4" data-id="element-2295" data-mp="1slrcrn5yb52q">
                  <span className="font-medium" data-id="element-2296" data-mp="1oil5cc73r7uo">1.</span> From the home screen,
                  tap <strong data-id="element-2297" data-mp="3mxft9trtzfp8">Theory Practice</strong>.
                </p>
                <p className="mb-4" data-id="element-2298" data-mp="3mvliv9e6r5ze">
                  <span className="font-medium" data-id="element-2299" data-mp="3ivktitpjtadk">2.</span> You can purchase
                  access to the Total Drive Theory Suite for just £4.99.
                </p>
                <p className="mb-4" data-id="element-2300" data-mp="1g7ci8xbv9vqn">
                  <span className="font-medium" data-id="element-2301" data-mp="1l0p798kgk4jx">3.</span> The Theory Suite
                  includes:
                </p>
                <ul className="space-y-2 mb-6 pl-6" data-id="element-2302" data-mp="179shdphx21gk">
                  <li className="list-disc" data-id="element-2303" data-mp="1bacb0j3a6mxy">
                    Official DVSA Theory Test questions
                  </li>
                  <li className="list-disc" data-id="element-2304" data-mp="1yzeyw8oidc0w">Hazard Perception videos</li>
                  <li className="list-disc" data-id="element-2305" data-mp="23z1egort74cv">Practice by subject</li>
                  <li className="list-disc" data-id="element-2306" data-mp="23y8hgfinjt7x">Real-time mock tests</li>
                </ul>
                <div className="bg-green-50 border-l-4 border-green-400 p-4 mt-6" data-id="element-2307" data-mp="1pyqnllqi1prp">
                  <p className="text-sm text-green-800" data-id="element-2308" data-mp="1uxad1w4axjot">
                    <strong data-id="element-2309" data-mp="ek3dn4dtnnb9">Tip:</strong> Regular theory practice is essential
                    for passing your test the first time. We recommend 20
                    minutes of practice daily.
                  </p>
                </div>
              </div>
              <div className="flex flex-col justify-center gap-4" data-id="element-2310" data-mp="b0l0vvhiwyyn">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tj6ahZ1CWpcgrBTcoxp7aA/10._Theory_Practice_2.jpg" alt="Total Drive App Theory Suite Payment" className="max-w-[250px] border border-gray-300 rounded-md shadow-md mx-auto" data-id="element-2311" data-mp="71c56l2xar0g" />
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vuMREizzouevNyrxcivgNb/10._Theory_Practice.jpg" alt="Total Drive App Theory Practice Features" className="max-w-[250px] border border-gray-300 rounded-md shadow-md mx-auto" data-id="element-2312" data-mp="3ohu2g2e18gy3" />
              </div>
            </div>
          </section>
          {/* Step 12 */}
          <section id="step12" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2313" data-mp="35p9nlov64cda">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2314" data-mp="30pdj7oik6ix7">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2315" data-mp="2f9gd7m6t1epd">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2316" data-mp="2k6pz4ruzj88g">
                  12
                </span>
                Use Reflective Logs for Learning
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2317" data-mp="2u32stpqj5m37">
              <div data-id="element-2318" data-mp="2y6hkjdntzqwh">
                <p className="mb-4" data-id="element-2319" data-mp="2y4y49n26dfup">
                  <span className="font-medium" data-id="element-2320" data-mp="335lrdxna9cjn">1.</span> From the home screen,
                  tap <strong data-id="element-2321" data-mp="37x3v2tgoxr8b">Reflective Logs</strong>.
                </p>
                <p className="mb-4" data-id="element-2322" data-mp="37yx42fes0njh">
                  <span className="font-medium" data-id="element-2323" data-mp="3cwggravtss9b">2.</span> After each lesson,
                  create a new log entry to record:
                </p>
                <ul className="space-y-2 mb-6 pl-6" data-id="element-2324" data-mp="3hwkw2xkzzgxy">
                  <li className="list-disc" data-id="element-2325" data-mp="3lw3ijxsgw02w">
                    What you achieved during the lesson
                  </li>
                  <li className="list-disc" data-id="element-2326" data-mp="1aab7kwwkmx7h">Skills you've developed</li>
                  <li className="list-disc" data-id="element-2327" data-mp="16751pqddf81j">Areas you want to improve</li>
                  <li className="list-disc" data-id="element-2328" data-mp="16a0yvche9sox">
                    Action plans for your next session
                  </li>
                </ul>
                <p className="mb-4" data-id="element-2329" data-mp="waihn3svcl0k">
                  <span className="font-medium" data-id="element-2330" data-mp="wbbijo55cgas">3.</span> View past logs to
                  track your progress over time.
                </p>
                <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mt-6" data-id="element-2331" data-mp="1oxmg0pxgi13d">
                  <p className="text-sm text-blue-800" data-id="element-2332" data-mp="1k7fskteokmmp">
                    <strong data-id="element-2333" data-mp="1k5uzz9bxfdrh">Note:</strong> Reflective logs help you identify
                    patterns in your learning and accelerate your progress
                    toward test readiness.
                  </p>
                </div>
              </div>
              <div className="flex justify-center" data-id="element-2334" data-mp="27wi89vpr85ek">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uyqDSHaS4oyuff1pzA7UmY/11._Refelctive_Log.jpg" alt="Total Drive App Reflective Logs" className="max-w-full rounded-lg shadow-md mx-auto" data-id="element-2335" data-mp="27vpbnnkiewa5" />
              </div>
            </div>
          </section>
          {/* Step 13 */}
          <section id="step13" className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-2336" data-mp="3dn7nbsotr2ya">
            <div className="bg-burgundy-600 text-white py-3 px-6" data-id="element-2337" data-mp="3six4ndj2erwo">
              <h2 className="text-xl font-bold flex items-center" data-id="element-2338" data-mp="3nmgdsbkhdzfw">
                <span className="bg-white text-burgundy-600 w-7 h-7 rounded-full flex items-center justify-center mr-3 text-sm font-bold" data-id="element-2339" data-mp="57nyd5v6s6p1">
                  13
                </span>
                Access Premium Learning Aids{' '}
                <span className="ml-2 bg-green-500 text-white text-xs px-2 py-0.5 rounded-full" data-id="element-2340" data-mp="f6wspztyrnbx">
                  FREE
                </span>
              </h2>
            </div>
            <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2341" data-mp="ts0uy4aio3gr">
              <div data-id="element-2342" data-mp="tqpsc7st51r8">
                <p className="mb-4" data-id="element-2343" data-mp="yrdfujhtv0gp">
                  <span className="font-medium" data-id="element-2344" data-mp="yqc6qkkdgo1m">1.</span> From the home screen,
                  tap <strong data-id="element-2345" data-mp="jtcom2rw9csw">Learning Aids</strong>.
                </p>
                <p className="mb-4" data-id="element-2346" data-mp="oth9s63qyvpg">
                  <span className="font-medium" data-id="element-2347" data-mp="osfs3is87ayr">2.</span> Explore premium
                  teaching materials that include:
                </p>
                <ul className="space-y-2 mb-6 pl-6" data-id="element-2348" data-mp="b081y9vg6i91">
                  <li className="list-disc" data-id="element-2349" data-mp="ftudtztsei3s">Digital Driving Course</li>
                  <li className="list-disc" data-id="element-2350" data-mp="144x2w97o5ie">36 Training Material Videos</li>
                  <li className="list-disc" data-id="element-2351" data-mp="12217vldni5r">Junctions, Manoeuvres & more</li>
                  <li className="list-disc" data-id="element-2352" data-mp="63971p3ym79s">Voiceover Audio Option</li>
                </ul>
                <p className="mb-4" data-id="element-2353" data-mp="3o94dl1a7fb8e">
                  <span className="font-medium" data-id="element-2354" data-mp="3sa6dzlfuxtby">3.</span> These 3D video courses
                  provide visual learning to complement your practical lessons.
                </p>
                <div className="bg-green-50 border-l-4 border-green-400 p-4 mt-6" data-id="element-2355" data-mp="1ytjz5cen2fay">
                  <p className="text-sm text-green-800" data-id="element-2356" data-mp="1tzfpumhwhv6p">
                    <strong data-id="element-2357" data-mp="1p14ci1sed2jq">Exclusive Benefit:</strong> While Learning Aids is
                    normally a premium paid service, Northampton Driving School
                    offers this valuable resource{' '}
                    <strong data-id="element-2358" data-mp="2hpa0cxeqz7ns">completely FREE</strong> to all our students!
                  </p>
                </div>
              </div>
              <div className="flex justify-center" data-id="element-2359" data-mp="2cs1kj3h2nfpp">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ef7AdFrgTv9UA6N7T195GW/12._Learning_Aids_FREE.jpg" alt="Total Drive App Learning Aids showing 3D video courses" className="max-w-[300px] rounded-lg shadow-md mx-auto" data-id="element-2360" data-mp="27rdt4goxkwuy" />
              </div>
            </div>
          </section>
          {/* Closing Section */}
          <section className="bg-burgundy-50 border border-burgundy-200 rounded-lg p-8 text-center" data-id="element-2361" data-mp="33zjjcyzql6ak">
            <h2 className="text-2xl font-bold mb-4" data-id="element-2362" data-mp="37zk4t3l96hr4">
              Take Control of Your Driving Journey
            </h2>
            <p className="mb-6 max-w-2xl mx-auto" data-id="element-2363" data-mp="3cxvhrn6uh8dk">
              With the Total Drive app, you're always in control of your
              learning. From booking lessons to tracking your driving ability,
              everything is available in one place.
            </p>
            <p className="mb-8 font-medium" data-id="element-2364" data-mp="3rnjkmsuocf3e">
              Ready to begin? Book your driving lessons in Northampton today and
              start using the Total Drive app with Northampton Driving School.
            </p>
            <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-8 py-3 rounded-md font-medium inline-flex items-center transition-colors" data-id="element-2365" data-mp="4ibtz3oy0i5w">
              Book Your First Lesson
              <ArrowRightIcon size={16} className="ml-2" data-id="element-2366" data-mp="1628ev8km8put" />
            </a>
          </section>
        </div>
      </div>
    </div>;
};
export default TotalDrivePage;